import hrMessages from '../locales/sr_RS.json';

const srLang = {
  messages: {
    ...hrMessages,
  },
  locale: 'sr-RS',
};
export default srLang;
